// Returns the "Diplo Get It" bookmarklet code.
// Users drag this link to their browser bookmark bar. When clicked on any
// article page, it captures the current page URL and opens the Diplo
// Summarizer with that URL pre-loaded as `article1`.
export function getDiploGetterBookmarklet() {
    return `
    javascript:
    var d=document,
    w=window,
    e=w.getSelection,
    k=d.getSelection,
    x=d.selection,
    s=(e?e():(k)?k():(x?x.createRange().text:0)),
    f='` + process.env.REACT_APP_URL + `/ai-writer/summarizer',
    l=d.location,
    e=encodeURIComponent,
    u=f+'?article1='+e(l.protocol+'//'+l.host+l.pathname+l.search);
    a=function(){if(!w.open(u,'t','toolbar=0,resizable=1,scrollbars=1,status=1,width=900px,height=600px'))l.href=u;};
    if (/Firefox/.test(navigator.userAgent)) setTimeout(a, 0); else a();
    void(0)`;
}
